import type {
  NavigationMenuItemStoryblok,
  NavigationMenuWrapperStoryblok,
} from '~/types/storyblok'

type SlideTransition = 'slide-left' | 'slide-right'

export const useMobileNavStore = defineStore('mobile-nav', () => {
  const navIsActive = ref(false)
  const activeNavMenuLabel = ref(null)
  const activeNavMenu = ref(null)
  const navHistory = ref([])
  const slideTransition = ref<SlideTransition>('slide-left')

  function openNav() {
    navIsActive.value = true
  }
  function closeNav() {
    navIsActive.value = false
    navHistory.value = []
  }
  function goBack() {
    slideTransition.value = 'slide-right'
    const previousMenu = navHistory.value.slice(-1)[0]
    activeNavMenu.value = previousMenu.menu
    activeNavMenuLabel.value = previousMenu.label
    navHistory.value.pop()
  }

  function showMobileNav({
    menu,
    label,
  }: {
    menu: NavigationMenuItemStoryblok[] | NavigationMenuWrapperStoryblok[]
    label: string
  }) {
    slideTransition.value = 'slide-left'
    activeNavMenu.value = menu
    activeNavMenuLabel.value = label
  }

  function showMobileNavChild({
    menu,
    label,
  }: {
    menu: NavigationMenuItemStoryblok[] | NavigationMenuWrapperStoryblok[]
    label: string
  }) {
    navHistory.value.push({
      menu: activeNavMenu.value,
      label: activeNavMenuLabel.value,
    })
    showMobileNav({ menu, label })
  }

  return {
    openNav,
    closeNav,
    goBack,
    showMobileNav,
    showMobileNavChild,
    activeNavMenu,
    activeNavMenuLabel,
    navIsActive,
    slideTransition,
    navHistory,
  }
})
